<template>
  <div class="app-container dashboard-summary">
    <!-- 筛选栏 -->
    <div class="filter-container">
      <el-form :inline="true" size="small">
        <el-form-item label="订单时间">
          <el-date-picker
            v-model="dateArr"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>
        <el-form-item label="下游客户">
          <el-select
            v-model="listQuery.app_client_id"
            placeholder="全部客户"
            style="width: 150px"
            clearable
            filterable
          >
            <el-option label="全部客户" :value="0" />
            <el-option
              v-for="client in appClientList"
              :key="client.id"
              :label="client.name"
              :value="client.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="上游渠道">
          <el-select
            v-model="listQuery.target_type"
            placeholder="全部渠道"
            style="width: 130px"
            clearable
            filterable
          >
            <el-option label="全部渠道" value="" />
            <el-option
              v-for="channel in channelList"
              :key="channel.value"
              :label="channel.label"
              :value="channel.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="对比">
          <el-select v-model="listQuery.compare_type" style="width: 90px">
            <el-option label="环比" value="hb" />
            <el-option label="同比" value="tb" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Hero实时概览 -->
    <div class="hero">
      <div class="hero-left">
        <span class="hero-badge">实时概览</span>
        <div class="hero-time">截至 {{ realtimeData.now }}</div>
      </div>
      <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日同期增长率</div>
        <div
          class="hero-rate"
          :class="realtimeData.growthRate >= 0 ? 'up' : 'down'"
        >
          {{ realtimeData.growthRate >= 0 ? '↑' : '↓' }}
          {{ Math.abs(realtimeData.growthRate) }}%
        </div>
        <div class="hero-sub">今日累计 vs 昨日同期累计</div>
      </div>
      <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日营业额(实时)</div>
        <div class="hero-big">¥{{ formatMoney(realtimeData.todaySales) }}</div>
        <div class="hero-sub">
          较昨日同期 {{ realtimeData.yestSameRate >= 0 ? '+' : ''
          }}{{ realtimeData.yestSameRate }}%
        </div>
      </div>
      <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日订单量(实时)</div>
        <div class="hero-big">{{ realtimeData.todayOrders }} 单</div>
        <div class="hero-sub">
          较昨日同期 {{ realtimeData.orderRate >= 0 ? '+' : ''
          }}{{ realtimeData.orderRate }}%
        </div>
      </div>
      <!-- <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日间夜数(实时)</div>
        <div class="hero-big">{{ realtimeData.todayNights }} 间夜</div>
        <div class="hero-sub">
          较昨日同期 {{ realtimeData.nightsRate >= 0 ? '+' : ''
          }}{{ realtimeData.nightsRate }}%
        </div>
      </div> -->
      <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日充值金额</div>
        <div class="hero-big" style="color: #e6a23c">
          ¥{{ formatMoney(realtimeData.todayRecharge) }}
        </div>
      </div>
    </div>

    <!-- 6 KPI卡片 -->
    <el-row :gutter="16" class="kpi-row">
      <el-col :span="4" v-for="k in kpiTop" :key="k.label">
        <el-card shadow="hover" class="kpi-card">
          <div class="kpi-label">{{ k.label }}</div>
          <div class="kpi-val" :class="k.cls">{{ k.val }}</div>
          <div class="kpi-sub">{{ k.sub }}</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 今日实时 vs 昨日对比表 -->
    <el-card class="mb18" shadow="never">
      <div slot="header" class="sec-title">
        今日实时 vs 昨日对比<span class="sub"
          >时间粒度计 → 截至 {{ realtimeData.now }} 的当日累计</span
        >
      </div>
      <el-table
        :data="cmpRows"
        border
        size="small"
        :header-cell-style="{
          background: '#fafafa',
          color: '#909399',
          fontWeight: 500,
        }"
      >
        <el-table-column
          prop="metric"
          label="指标"
          width="110"
        ></el-table-column>
        <el-table-column
          prop="today"
          label="今日(同时段累计)"
        ></el-table-column>
        <el-table-column prop="yest" label="昨日同时段"></el-table-column>
        <el-table-column prop="rate" label="增长率" width="110">
          <template slot-scope="scope">
            <span
              :class="getRateClass(scope.row.rate)"
              style="font-size: 13px; font-weight: 600"
              >{{ scope.row.rate }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="yfull"
          label="昨日全天"
          width="120"
        ></el-table-column>
      </el-table>
    </el-card>

    <!-- 12 KPI卡片 -->
    <el-row :gutter="16" class="kpi-row mb18">
      <el-col :span="4" v-for="k in kpiGrid" :key="k.label">
        <el-card shadow="hover" class="kpi-card">
          <div class="kpi-label">{{ k.label }}</div>
          <div class="kpi-val" :class="k.cls">{{ k.val }}</div>
          <div class="kpi-sub" v-html="k.sub"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 核心运营指标 -->
    <el-card shadow="never" class="mb18">
      <div class="chart-t" style="margin-bottom: 16px">核心运营指标</div>
      <div class="bottom-strip">
        <div class="bk-item">
          <div class="bk-label">平均退单率</div>
          <div
            class="bk-val"
            :class="getRateClass(operationData.refundRate, 'refund')"
          >
            {{ operationData.refundRate }}%
          </div>
          <div class="bk-sub">行业良好线 &lt; 8%</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">平均预订成功率</div>
          <div
            class="bk-val"
            :class="getRateClass(operationData.successRate, 'success')"
          >
            {{ operationData.successRate }}%
          </div>
          <div class="bk-sub">目标 ≥ 85%</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">近30天复购率</div>
          <div
            class="bk-val"
            :class="getRateClass(operationData.repurchaseRate, 'repurchase')"
          >
            {{ operationData.repurchaseRate }}%
          </div>
          <div class="bk-sub">
            较上月 {{ formatPpChange(operationData.repurchaseRateChange) }}
          </div>
        </div>
        <div class="bk-item">
          <div class="bk-label">平均入住间夜数</div>
          <div class="bk-val" style="color: #303133">
            {{ operationData.avgNights }} 间夜
          </div>
          <div class="bk-sub">行业标准 1.5 间夜</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">平均提前预订天数</div>
          <div class="bk-val" style="color: #303133">
            {{ operationData.avgLeadDays }} 天
          </div>
          <div class="bk-sub">反应决策周期</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">订单处理时效</div>
          <div class="bk-val" style="color: #303133">
            {{ operationData.avgHandleSeconds }} 秒
          </div>
          <div class="bk-sub">下单到确认耗时</div>
        </div>
      </div>
    </el-card>

    <!-- 经营趋势 -->
    <el-card class="chart-card mb18" shadow="never">
      <div class="chart-hd">
        <div class="chart-t">
          经营趋势<span class="sub">按下单时间统计</span>
        </div>
        <div style="display: flex; gap: 14px; align-items: center">
          <el-radio-group
            v-model="trendTab"
            size="small"
            @change="fetchTrendChart"
          >
            <el-radio-button label="营业额"></el-radio-button>
            <el-radio-button label="订单量"></el-radio-button>
            <el-radio-button label="客单价"></el-radio-button>
          </el-radio-group>
          <el-radio-group
            v-model="trendRange"
            size="small"
            @change="fetchTrendChart"
          >
            <el-radio-button label="近7天"></el-radio-button>
            <el-radio-button label="近30天"></el-radio-button>
            <el-radio-button label="近90天"></el-radio-button>
            <el-radio-button label="全部"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div ref="trendChart" class="echart" style="height: 320px"></div>
    </el-card>

    <!-- 3图：渠道占比、订单状态、分时下单 -->
    <el-row :gutter="12" class="mb18">
      <el-col :span="8">
        <el-card class="chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-t" style="margin-bottom: 10px">上游渠道占比</div>
          <div ref="channelPieChart" class="echart" style="height: 240px"></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-t" style="margin-bottom: 10px">订单状态分布</div>
          <div
            ref="statusDonutChart"
            class="echart"
            style="height: 240px"
          ></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-t" style="margin-bottom: 10px">今日分时下单</div>
          <div ref="hourlyBarChart" class="echart" style="height: 240px"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 2图：城市TOP10、客户贡献度 -->
    <el-row :gutter="12" class="mb18">
      <el-col :span="14">
        <el-card class="chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-hd">
            <div class="chart-t">目的地城市 TOP10</div>
            <el-radio-group
              v-model="cityTab"
              size="small"
              @change="fetchCityChart"
            >
              <el-radio-button label="订单量"></el-radio-button>
              <el-radio-button label="营业额"></el-radio-button>
            </el-radio-group>
          </div>
          <div ref="cityBarChart" class="echart" style="height: 260px"></div>
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card class="chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-t" style="margin-bottom: 10px">
            客户贡献度<span class="sub">帕累托分析</span>
          </div>
          <div ref="paretoChart" class="echart" style="height: 260px"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import * as echarts from 'echarts'
import moment from 'moment'
import { fetchTargetTypes } from '@/utils/targetType'

export default {
  name: 'DashboardSummary',
  data() {
    return {
      listQuery: {
        app_client_id: 0,
        target_type: '',
        compare_type: 'hb',
        start_at: '',
        end_at: '',
      },
      dateArr: null,
      appClientList: [],
      channelList: [],

      realtimeData: {
        now: '',
        todaySales: 0,
        todayOrders: 0,
        todayNights: 0,
        yestRecharge: 0,
        todayRecharge: 0,
        growthRate: 0,
        yestSameRate: 0,
        orderRate: 0,
        nightsRate: 0,
      },

      kpiTop: [],
      kpiGrid: [],
      cmpRows: [],

      operationData: {
        refundRate: 0,
        successRate: 0,
        repurchaseRate: 0,
        repurchaseRateChange: 0,
        avgNights: 0,
        avgLeadDays: 0,
        avgHandleSeconds: 0,
      },

      trendTab: '营业额',
      trendRange: '近30天',
      cityTab: '订单量',

      refreshTimer: null,
      trendChartInstance: null,
      channelChartInstance: null,
      statusChartInstance: null,
      hourlyChartInstance: null,
      cityChartInstance: null,
      paretoChartInstance: null,
      chartResizeHandler: null,
      requestVersion: 0,

      // 缓存维度数据，避免重复请求
      cachedDimensions: {
        channel: [],
        status: [],
        hourly: [],
        city: [],
      },
    }
  },
  created() {
    this.getAppClientList()
    this.getChannelList()
    this.startAutoRefresh()
    this.$nextTick(() => {
      this.fetchAllData()
    })
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
    this.destroyCharts()
  },
  methods: {
    async fetchAllData() {
      const version = ++this.requestVersion
      const params = this.getQueryParams()

      const [
        realtimeRes,
        indexRes,
        yesterdayRes,
        dimensionsRes,
        trendRes,
        contributionRes,
      ] = await Promise.all([
        this.requestSafe({
          url: '/api/backend/dataCount/realtime',
          method: 'get',
          params,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/index',
          method: 'get',
          params,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/yesterday',
          method: 'get',
          params,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/dimensions',
          method: 'get',
          params,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/salasChart',
          method: 'get',
          params: this.getTrendParams(),
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/contribution',
          method: 'get',
          params: this.getQueryParams({ top_n: 10 }),
        }),
      ])

      if (version !== this.requestVersion) return

      const realtimeData = realtimeRes?.data
      const indexData = indexRes?.data
      const yesterdayData = yesterdayRes?.data

      if (realtimeData) {
        this.applyRealtimeData(realtimeData)
      }
      if (indexData || yesterdayData || realtimeData) {
        this.applyKpiData(
          indexData || {},
          yesterdayData || {},
          realtimeData || {},
        )
      }
      if (realtimeData || yesterdayData) {
        this.applyComparison(realtimeData || {}, yesterdayData || {})
      }
      if (indexData) {
        this.applyOperationData(indexData)
      }
      this.applyDimensionsData(dimensionsRes?.data || {})
      if (trendRes?.data) {
        this.initTrendChart(trendRes.data)
      }

      const contributionData = contributionRes?.data || {}
      this.initParetoChart(
        contributionData.clients || [],
        contributionData.total || 0,
      )
    },

    getQueryParams(extra = {}) {
      return {
        ...this.listQuery,
        app_client_id: this.listQuery.app_client_id || 0,
        ...extra,
      }
    },

    requestSafe(config) {
      return request(config).catch(() => null)
    },

    getTrendParams() {
      const rangeMap = { 近7天: 7, 近30天: 30, 近90天: 90, 全部: 0 }
      const days = rangeMap[this.trendRange] ?? 30

      return {
        ...this.getQueryParams(),
        start_at:
          days > 0
            ? moment().subtract(days, 'days').format('YYYY-MM-DD 00:00:00')
            : '',
        end_at: moment().format('YYYY-MM-DD 23:59:59'),
        type: 'day',
      }
    },

    fetchRealtime() {
      return this.requestSafe({
        url: '/api/backend/dataCount/realtime',
        method: 'get',
        params: this.getQueryParams(),
      }).then((response) => {
        if (response?.data) {
          this.applyRealtimeData(response.data)
        }
      })
    },

    applyRealtimeData(data) {
      this.realtimeData = {
        now: data.now || moment().format('YYYY-MM-DD HH:mm:ss'),
        todaySales: data.today?.sales_cum || 0,
        todayOrders: data.today?.order_cum || 0,
        todayNights: data.today?.room_nights_cum || 0,
        yestRecharge: data.recharge?.yesterday || 0,
        todayRecharge: data.recharge?.today || 0,
        growthRate: this.calcGrowthRate(
          data.today?.sales_cum,
          data.yesterday_same_period?.sales_cum,
        ),
        yestSameRate: this.calcGrowthRate(
          data.today?.sales_cum,
          data.yesterday_same_period?.sales_cum,
        ),
        orderRate: this.calcGrowthRate(
          data.today?.order_cum,
          data.yesterday_same_period?.order_cum,
        ),
        nightsRate: this.calcGrowthRate(
          data.today?.room_nights_cum,
          data.yesterday_same_period?.room_nights_cum,
        ),
      }
    },

    applyKpiData(data, yest, realtime) {
      const yesterdayRecharge =
        realtime.recharge?.yesterday ?? data.yesterday_recharge ?? 0
      const yesterdaySales =
        parseFloat(yest.sales || data.yesterday_sales || 0) || 0
      const yesterdayRoomNights = parseFloat(yest.room_nights || 0) || 0
      const yesterdayAvgNightPrice = yesterdayRoomNights
        ? yesterdaySales / yesterdayRoomNights
        : 0
      this.kpiTop = [
        {
          label: '昨日营业额',
          val: '¥' + this.formatMoney(yest.sales || data.yesterday_sales || 0),
          cls: 'blue',
          sub: '全天合计',
        },
        {
          label: '昨日订单量',
          val: (yest.order_num || data.yesterday_order_num || 0) + ' 单',
          cls: 'dark',
          sub: '客单价 ¥' + (yest.adr || 0),
        },
        {
          label: '昨日间夜数',
          val: (yest.room_nights || 0) + ' 间夜',
          cls: 'dark',
          sub: '平均 ¥' + yesterdayAvgNightPrice.toFixed(2) + ' 间夜',
        },
        {
          label: '昨日充值金额',
          val: '¥' + this.formatMoney(yesterdayRecharge),
          cls: 'orange',
        },
        {
          label: '昨日退单率',
          val: (yest.refund_rate || 0) + '%',
          cls: 'red',
          sub: '行业良好线 < 8%',
        },
        {
          label: '昨日预订成功率',
          val: (yest.booking_success_rate || 0) + '%',
          cls: 'green',
          sub: '复购率 ' + (yest.repurchase_rate || 0) + '%',
        },
      ]
      this.kpiGrid = [
        {
          label: '累计营业额 ⓘ',
          val: '¥' + this.formatMoney(data.total_sales || 0),
          cls: 'blue',
          sub: '全量累计',
        },
        {
          label: '今日营业额',
          val: '¥' + this.formatMoney(data.today_sales || 0),
          cls: 'blue',
          sub:
            '<span style="color:#67C23A;">' +
            (data.today_sales_yesterday_compare_ratio || 0) +
            '% 较昨日</span>',
        },
        {
          label: '今日订单量',
          val: (data.today_order_num || 0) + ' 单',
          cls: 'dark',
          sub:
            '<span style="color:#67C23A;">' +
            (data.today_orders_yesterday_compare_ratio || 0) +
            '% 较昨日</span>',
        },
        {
          label: '今日客单价 ⓘ',
          val: '¥' + (data.today_adr || 0),
          cls: 'dark',
          sub: '票口 ¥' + (data.today_adr_port || 0),
        },
        {
          label: '下游客户数 ⓘ',
          val: (data.account_count || 0) + ' 家',
          cls: 'dark',
          sub: '活跃 ' + (data.active_clients || 0) + ' 家',
        },
        {
          label: '累计订单量',
          val: this.formatNumber(data.total_order_num || 0),
          cls: 'dark',
          sub:
            '近30天 ' +
            this.formatNumber(data.last_30_days_order_num || 0) +
            ' 单',
        },
        {
          label: '今日充值',
          val: '¥' + this.formatMoney(data.today_recharge || 0),
          cls: 'orange',
          sub: '实时到账',
        },
        {
          label: '昨日充值',
          val: '¥' + this.formatMoney(yesterdayRecharge),
          cls: 'orange',
          sub: '',
        },
        {
          label: '近30天充值',
          val: '¥' + this.formatMoney(data.last_30_days_recharge || 0),
          cls: 'orange',
          sub: '日均 ¥' + this.formatMoney(data.avg_daily_recharge || 0),
        },
        {
          label: '历史充值总额',
          val: '¥' + this.formatMoney(data.historical_recharge || 0),
          cls: 'orange',
          sub: '全部账户共' + (data.account_count || 0) + '个',
        },
        // {
        //   label: '预估毛利',
        //   val: '¥' + this.formatMoney(data.gross_profit || 0),
        //   cls: 'green',
        //   sub: '毛利率 ' + (data.gross_margin || 0) + '%',
        // },
        {
          label: '待结算金额',
          val: '¥' + this.formatMoney(data.unsettled_amount || 0),
          cls: 'red',
          sub: '账期未结清',
        },
        {
          label: '退佣金',
          val: '¥' + this.formatMoney(data.channel_commission || 0),
          cls: 'purple',
          sub: '综合费率 ' + (data.commission_rate || 0) + '%',
        },
      ]
    },

    applyComparison(realtimeData, yesterdayData) {
      const today = realtimeData.today || {}
      const yestSame = realtimeData.yesterday_same_period || {}
      const yestFull = yesterdayData || {}
      this.cmpRows = [
        {
          metric: '资金额',
          today: '¥' + this.formatMoney(today.sales_cum || 0),
          yest: '¥' + this.formatMoney(yestSame.sales_cum || 0),
          rate: this.calcRateStr(today.sales_cum, yestSame.sales_cum),
          yfull: '¥' + this.formatMoney(yestFull.sales || 0),
        },
        {
          metric: '订单量',
          today: (today.order_cum || 0) + ' 单',
          yest: (yestSame.order_cum || 0) + ' 单',
          rate: this.calcRateStr(today.order_cum, yestSame.order_cum),
          yfull: (yestFull.order_num || 0) + ' 单',
        },
        {
          metric: '间夜数',
          today: (today.room_nights_cum || 0) + ' 间夜',
          yest: (yestSame.room_nights_cum || 0) + ' 间夜',
          rate: this.calcRateStr(
            today.room_nights_cum,
            yestSame.room_nights_cum,
          ),
          yfull: (yestFull.room_nights || 0) + ' 间夜',
        },
        {
          metric: '客单价 ADR',
          today: (() => {
            const sales = parseFloat(today.sales_cum) || 0
            const orders = parseFloat(today.order_cum) || 0
            return orders > 0 ? '¥' + (sales / orders).toFixed(2) : '—'
          })(),
          yest: (() => {
            const sales = parseFloat(yestSame.sales_cum) || 0
            const orders = parseFloat(yestSame.order_cum) || 0
            return orders > 0 ? '¥' + (sales / orders).toFixed(2) : '—'
          })(),
          rate: (() => {
            const todayADR =
              (parseFloat(today.sales_cum) || 0) /
              (parseFloat(today.order_cum) || 0)
            const yestADR =
              (parseFloat(yestSame.sales_cum) || 0) /
              (parseFloat(yestSame.order_cum) || 0)
            if (today.order_cum > 0 && yestSame.order_cum > 0) {
              return this.calcRateStr(todayADR, yestADR)
            }
            return '—'
          })(),
          yfull: '¥' + (yestFull.adr || 0),
        },
        {
          metric: '充值金额',
          today: '¥' + this.formatMoney(realtimeData.recharge?.today || 0),
          yest: '—',
          rate: '—',
          yfull: '¥' + this.formatMoney(realtimeData.recharge?.yesterday || 0),
        },
      ]
    },

    applyOperationData(data) {
      this.operationData = {
        refundRate: data.avg_refund_rate || 0,
        successRate: data.avg_booking_success_rate || 0,
        repurchaseRate: data.repurchase_rate || 0,
        repurchaseRateChange: data.repurchase_rate_change || 0,
        avgNights: data.avg_nights || 0,
        avgLeadDays: data.avg_lead_days || 0,
        avgHandleSeconds: data.avg_handle_seconds || 0,
      }
    },

    getAppClientList() {
      request({
        url: '/api/backend/dataCount/appClientList',
        method: 'get',
        params: { limit: 500, quick_filter: 'all' },
      }).then((response) => {
        const payload = response.data || []
        this.appClientList = Array.isArray(payload)
          ? payload
          : payload.data || []
      })
    },

    getChannelList() {
      fetchTargetTypes().then((types) => {
        this.channelList = (types || []).map((item) => ({
          label: item.label || item.name || item.value,
          value: item.value || item.id,
        }))
      })
    },

    fetchTrendChart() {
      return this.requestSafe({
        url: '/api/backend/dataCount/salasChart',
        method: 'get',
        params: this.getTrendParams(),
      }).then((response) => {
        if (response?.data) {
          this.initTrendChart(response.data)
        }
      })
    },

    fetchCityChart() {
      // 使用缓存的数据重新渲染城市图表
      if (this.cachedDimensions.city?.length) {
        this.initCityChart(this.cachedDimensions.city)
      } else {
        this.initCityChart([])
      }
    },

    // 一次性获取所有维度数据，避免重复调用 API
    fetchDimensions() {
      request({
        url: '/api/backend/dataCount/dimensions',
        method: 'get',
        params: this.getQueryParams(),
      })
        .then((response) => {
          this.applyDimensionsData(response.data || {})
        })
        .catch(() => {
          this.applyDimensionsData({})
        })
    },

    applyDimensionsData(data) {
      this.cachedDimensions = {
        channel: data.channel || [],
        status: data.status || [],
        hourly: data.hourly || [],
        city: data.city || [],
      }
      this.initChannelChart(data.channel || [])
      this.initStatusChart(data.status || [])
      this.initHourlyChart(data.hourly || [])
      this.initCityChart(data.city || [])
    },

    fetchParetoChart() {
      if (!this.$refs.paretoChart) return
      this.requestSafe({
        url: '/api/backend/dataCount/contribution',
        method: 'get',
        params: this.getQueryParams({ top_n: 10 }),
      }).then((response) => {
        if (!response?.data) {
          this.initParetoChart([], 0)
          return
        }
        const data = response.data || {}
        const clients = data.clients || []
        this.initParetoChart(clients, data.total)
      })
    },

    initTrendChart(data) {
      if (!this.$refs.trendChart) return
      if (!this.trendChartInstance) {
        this.trendChartInstance = echarts.init(this.$refs.trendChart)
      }
      const dates = data.dates || []
      const sales = (data.salas_chart_list || []).map((v) => parseFloat(v) || 0)
      const orders = (data.order_num_chart_list || []).map(
        (v) => parseFloat(v) || 0,
      )
      const rev =
        this.trendTab === '订单量'
          ? orders
          : this.trendTab === '客单价'
          ? sales.map((v, index) =>
              orders[index] ? Number((v / orders[index]).toFixed(2)) : 0,
            )
          : sales
      const avg = this.calcMovingAverage(rev, 7)

      // 系列名称
      const seriesName = this.trendTab
      const yAxisName = this.trendTab === '客单价' ? '金额' : this.trendTab

      this.trendChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        legend: {
          data: [seriesName, '7日移动平均'],
          top: 0,
          right: 10,
          textStyle: { fontSize: 12 },
        },
        grid: { left: 55, right: 55, top: 45, bottom: 30 },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: { fontSize: 10, color: '#909399' },
          axisLine: { lineStyle: { color: '#e4e7ed' } },
          axisTick: { show: false },
        },
        yAxis: {
          type: 'value',
          name: yAxisName,
          axisLabel: { fontSize: 10, color: '#909399' },
          splitLine: { lineStyle: { color: '#f0f2f5' } },
        },
        series: [
          {
            name: seriesName,
            type: 'line',
            data: rev,
            smooth: true,
            lineStyle: { color: '#409EFF', width: 2.5 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(64,158,255,0.18)' },
                { offset: 1, color: 'rgba(64,158,255,0.01)' },
              ]),
            },
            itemStyle: { color: '#409EFF' },
            symbol: 'circle',
            symbolSize: 6,
            markPoint: {
              symbol: 'pin',
              symbolSize: 48,
              data: [
                { type: 'max', name: '峰值' },
                { type: 'min', name: '低值' },
              ],
              label: { fontSize: 10, color: '#fff', fontWeight: 600 },
              itemStyle: { color: '#409EFF' },
            },
          },
          {
            name: '7日移动平均',
            type: 'line',
            data: avg,
            smooth: true,
            lineStyle: { color: '#E6A23C', width: 1.5, type: 'dashed' },
            itemStyle: { color: '#E6A23C' },
            symbol: 'none',
          },
        ],
      })
      this.ensureChartResize()
    },

    initChannelChart(channelData) {
      if (!this.$refs.channelPieChart) return
      if (!this.channelChartInstance) {
        this.channelChartInstance = echarts.init(this.$refs.channelPieChart)
      }
      this.channelChartInstance.setOption({
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
        series: [
          {
            type: 'pie',
            radius: ['45%', '72%'],
            center: ['50%', '55%'],
            label: {
              formatter: '{b}\n{d}%',
              fontSize: 11,
              color: '#606266',
            },
            data: channelData || [],
          },
        ],
      })
      this.ensureChartResize()
    },

    initStatusChart(statusData) {
      if (!this.$refs.statusDonutChart) return
      if (!this.statusChartInstance) {
        this.statusChartInstance = echarts.init(this.$refs.statusDonutChart)
      }
      this.statusChartInstance.setOption({
        tooltip: { trigger: 'item' },
        series: [
          {
            type: 'pie',
            radius: ['48%', '73%'],
            center: ['50%', '55%'],
            label: {
              formatter: '{b}\n{d}%',
              fontSize: 10,
              color: '#606266',
            },
            data: statusData || [],
          },
        ],
      })
      this.ensureChartResize()
    },

    initHourlyChart(hourlyData) {
      if (!this.$refs.hourlyBarChart) return
      if (!this.hourlyChartInstance) {
        this.hourlyChartInstance = echarts.init(this.$refs.hourlyBarChart)
      }
      this.hourlyChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 40, right: 20, top: 20, bottom: 30 },
        xAxis: {
          type: 'category',
          data: this.getHourLabels(),
          axisLabel: { fontSize: 9, color: '#909399', interval: 2 },
          axisLine: { lineStyle: { color: '#e4e7ed' } },
          axisTick: { show: false },
        },
        yAxis: {
          type: 'value',
          splitLine: { lineStyle: { color: '#f0f2f5' } },
          axisLabel: { fontSize: 10, color: '#909399' },
        },
        series: [
          {
            type: 'bar',
            data: hourlyData || [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2b6cb0' },
                { offset: 1, color: '#5a9fd9' },
              ]),
              borderRadius: [4, 4, 0, 0],
            },
            barWidth: '55%',
          },
        ],
      })
      this.ensureChartResize()
    },

    initCityChart(cityData) {
      if (!this.$refs.cityBarChart) return
      if (!this.cityChartInstance) {
        this.cityChartInstance = echarts.init(this.$refs.cityBarChart)
      }
      const isOrder = this.cityTab === '订单量'
      const cities = (cityData || []).map((d) => d.name)
      const vals = (cityData || []).map((d) => (isOrder ? d.orders : d.sales))

      this.cityChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 60, right: 30, top: 10, bottom: 20 },
        xAxis: {
          type: 'value',
          splitLine: { lineStyle: { color: '#f0f2f5' } },
          axisLabel: { fontSize: 10, color: '#909399' },
        },
        yAxis: {
          type: 'category',
          data: cities,
          inverse: true,
          axisLabel: { fontSize: 11, color: '#303133' },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#e4e7ed' } },
        },
        series: [
          {
            type: 'bar',
            data: vals,
            itemStyle: { color: '#66B2FF', borderRadius: [0, 3, 3, 0] },
            barWidth: '55%',
            label: {
              show: true,
              position: 'right',
              fontSize: 10,
              color: '#303133',
            },
          },
        ],
      })
      this.ensureChartResize()
    },

    initParetoChart(clientData, totalAmount) {
      if (!this.$refs.paretoChart) return
      if (!this.paretoChartInstance) {
        this.paretoChartInstance = echarts.init(this.$refs.paretoChart)
      }
      // 处理客户端贡献度数据
      const data = clientData || []
      const names = data.map((d) => d.name)
      // 贡献额从元转换为万元
      const bars = data.map(
        (d) => Math.round((d.contribution_yuan / 10000) * 100) / 100,
      )
      let sum = 0
      const total =
        (parseFloat(totalAmount) || 0) > 0
          ? parseFloat(totalAmount) / 10000
          : bars.reduce((a, b) => a + b, 0) || 1
      const line = bars.map((v) => {
        sum += v
        return Math.round((sum / total) * 100)
      })

      this.paretoChartInstance.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
        },
        legend: {
          data: ['贡献额(万)', '累计占比'],
          top: 0,
          right: 10,
          textStyle: { fontSize: 11 },
        },
        grid: { left: 50, right: 50, top: 40, bottom: 50 },
        xAxis: {
          type: 'category',
          data: names,
          axisLabel: { fontSize: 9, color: '#909399', rotate: 30, interval: 0 },
          axisLine: { lineStyle: { color: '#e4e7ed' } },
          axisTick: { show: false },
        },
        yAxis: [
          {
            type: 'value',
            name: '金额',
            splitLine: { lineStyle: { color: '#f0f2f5' } },
            axisLabel: { fontSize: 10, color: '#909399' },
          },
          {
            type: 'value',
            name: '占比 %',
            min: 0,
            max: 100,
            axisLabel: {
              formatter: '{value}%',
              fontSize: 10,
              color: '#909399',
            },
            splitLine: { show: false },
          },
        ],
        series: [
          {
            name: '贡献额(万)',
            type: 'bar',
            data: bars,
            itemStyle: { color: '#90CAF9', borderRadius: [2, 2, 0, 0] },
            barWidth: '45%',
          },
          {
            name: '累计占比',
            type: 'line',
            yAxisIndex: 1,
            data: line,
            smooth: true,
            lineStyle: { color: '#F56C6C', width: 2 },
            itemStyle: { color: '#F56C6C' },
            symbol: 'circle',
            symbolSize: 5,
          },
        ],
      })
      this.ensureChartResize()
    },

    destroyCharts() {
      if (this.chartResizeHandler) {
        window.removeEventListener('resize', this.chartResizeHandler)
        this.chartResizeHandler = null
      }
      this.trendChartInstance?.dispose()
      this.channelChartInstance?.dispose()
      this.statusChartInstance?.dispose()
      this.hourlyChartInstance?.dispose()
      this.cityChartInstance?.dispose()
      this.paretoChartInstance?.dispose()
    },

    ensureChartResize() {
      if (this.chartResizeHandler) return
      this.chartResizeHandler = () => {
        this.trendChartInstance?.resize()
        this.channelChartInstance?.resize()
        this.statusChartInstance?.resize()
        this.hourlyChartInstance?.resize()
        this.cityChartInstance?.resize()
        this.paretoChartInstance?.resize()
      }
      window.addEventListener('resize', this.chartResizeHandler)
    },

    getRateClass(val, kind) {
      const v = parseFloat(val) || 0
      if (kind === 'refund') {
        if (v <= 8) return 'rate-green'
        if (v <= 15) return 'rate-orange'
        return 'rate-red'
      }
      if (kind === 'success') {
        if (v >= 95) return 'rate-green'
        if (v >= 85) return 'rate-orange'
        return 'rate-red'
      }
      if (kind === 'repurchase') {
        if (v >= 15) return 'rate-green'
        if (v >= 5) return 'rate-orange'
        return 'rate-red'
      }
      if (typeof val === 'string') {
        return val.indexOf('↑') >= 0
          ? 'hero-rate up'
          : val.indexOf('↓') >= 0
          ? 'hero-rate down'
          : ''
      }
      return v >= 0 ? 'hero-rate up' : 'hero-rate down'
    },

    calcGrowthRate(curr, prev) {
      const c = parseFloat(curr) || 0
      const p = parseFloat(prev) || 0
      if (!p || p === 0) return 0
      return (((c - p) / p) * 100).toFixed(1)
    },

    calcRateStr(curr, prev) {
      const c = parseFloat(curr) || 0
      const p = parseFloat(prev) || 0
      if (!p || p === 0) return '—'
      const rate = (((c - p) / p) * 100).toFixed(1)
      return rate >= 0 ? '↑' + rate + '%' : '↓' + Math.abs(rate) + '%'
    },

    calcMovingAverage(list, size = 7) {
      return (list || []).map((_, index) => {
        const start = Math.max(0, index - size + 1)
        const segment = list.slice(start, index + 1)
        const total = segment.reduce(
          (sum, val) => sum + (parseFloat(val) || 0),
          0,
        )
        return segment.length ? Number((total / segment.length).toFixed(2)) : 0
      })
    },

    formatPpChange(val) {
      const num = parseFloat(val) || 0
      return (num > 0 ? '+' : '') + num + 'pp'
    },

    formatMoney(val) {
      return parseFloat(val || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },

    formatNumber(val) {
      return parseInt(val || 0).toLocaleString('zh-CN')
    },

    getHourLabels() {
      return Array.from({ length: 24 }, (_, i) => i + ':00')
    },

    startAutoRefresh() {
      this.refreshTimer = setInterval(() => {
        this.fetchRealtime()
      }, 30000)
    },

    handleFilter() {
      if (this.dateArr) {
        this.listQuery.start_at = this.dateArr[0] + ' 00:00:00'
        this.listQuery.end_at = this.dateArr[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
      this.fetchAllData()
    },

    handleReset() {
      this.dateArr = null
      this.listQuery = {
        app_client_id: 0,
        target_type: '',
        compare_type: 'hb',
        start_at: '',
        end_at: '',
      }
      this.fetchAllData()
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-summary {
  .mb18 {
    margin-bottom: 18px;
  }

  .hero {
    background: #f6fbf7;
    border-radius: 8px;
    padding: 20px 28px;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 0;
  }
  .hero-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 120px;
  }
  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #67c23a;
    color: #fff;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.6;
    &::before {
      content: '';
      width: 6px;
      height: 6px;
      background: #fff;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
  .hero-time {
    font-size: 12px;
    color: #909399;
    margin-top: 6px;
    letter-spacing: 0.3px;
  }
  .hero-block {
    display: flex;
    flex-direction: column;
    padding: 0 36px;
  }
  .hero-label {
    font-size: 13px;
    color: #606266;
    margin-bottom: 4px;
    letter-spacing: 0.2px;
  }
  .hero-rate {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.2;
    &.up {
      color: #f56c6c;
    }
    &.down {
      color: #67c23a;
    }
  }
  .hero-big {
    font-size: 28px;
    font-weight: 700;
    color: #303133;
    line-height: 1.2;
  }
  .hero-sub {
    font-size: 12px;
    color: #909399;
    margin-top: 3px;
    line-height: 1.4;
  }
  .hero-sep {
    width: 1px;
    height: 56px;
    background: #dcece0;
    flex-shrink: 0;
  }

  .kpi-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    margin-right: -8px;
  }
  .kpi-card {
    height: -webkit-fill-available;
    margin-bottom: 16px;
    .kpi-label {
      font-size: 13px;
      color: #909399;
      margin-bottom: 10px;
    }
    .kpi-val {
      font-size: 22px;
      font-weight: 700;
      line-height: 1.1;
      &.blue {
        color: #409eff;
      }
      &.dark {
        color: #303133;
      }
      &.orange {
        color: #e6a23c;
      }
      &.red {
        color: #f56c6c;
      }
      &.green {
        color: #67c23a;
      }
      &.purple {
        color: #9b59b6;
      }
    }
    .kpi-sub {
      font-size: 11px;
      color: #b4b8bd;
      margin-top: 6px;
    }
  }

  .bottom-strip {
    background: #fff;
    border-radius: 6px;
    padding: 20px 24px;
    display: flex;
  }
  .bk-item {
    flex: 1;
    text-align: center;
    position: relative;
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 10%;
      height: 80%;
      width: 1px;
      background: #ebeef5;
    }
  }
  .bk-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 8px;
  }
  .bk-val {
    font-size: 22px;
    font-weight: 700;
  }
  .bk-sub {
    font-size: 11px;
    color: #b4b8bd;
    margin-top: 4px;
  }

  .sec-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    .sub {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      margin-left: 6px;
    }
  }
  .chart-t {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    .sub {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      margin-left: 6px;
    }
  }
  .chart-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .filter-container {
    background: #fff;
    border-radius: 6px;
    // padding: 16px 20px;
  }

  .rate-green {
    color: #67c23a !important;
  }
  .rate-orange {
    color: #e6a23c !important;
  }
  .rate-red {
    color: #f56c6c !important;
  }
}
</style>
